import React, { useState } from 'react';
// We'll set title and JSON-LD programmatically in a useEffect to avoid adding a
// new dependency that conflicts with the project's React version.
import { useNavigate } from 'react-router-dom';
import './Courses.css';

const Courses = () => {
    const navigate = useNavigate();
    React.useEffect(() => {
        const prevTitle = document.title;
        //document.title = 'Courses — PilotHelper'; -- remove page title

        // meta description
        let meta = document.querySelector('meta[name="description"][data-generated="courses-page"]');
        if (!meta) {
            meta = document.createElement('meta');
            meta.setAttribute('name', 'description');
            meta.setAttribute('data-generated', 'courses-page');
            document.head.appendChild(meta);
        }
        const prevDescription = meta.getAttribute('content');
        meta.setAttribute('content', 'Select from our range of peer support courses designed for aviation professionals.');

        // JSON-LD for WebPage + BreadcrumbList
        const ld = document.createElement('script');
        ld.type = 'application/ld+json';
        ld.setAttribute('data-generated', 'courses-jsonld');
        ld.text = JSON.stringify([
            {"@context":"https://schema.org","@type":"WebPage","name":"Courses","url":"https://pilothelper.com/courses"},
            {"@context":"https://schema.org","@type":"BreadcrumbList","itemListElement":[
                {"@type":"ListItem","position":1,"name":"Home","item":"https://pilothelper.com/"},
                {"@type":"ListItem","position":2,"name":"Courses","item":"https://pilothelper.com/courses"}
            ]}
        ]);
        document.head.appendChild(ld);

        return () => {
            document.title = prevTitle;
            if (meta) meta.setAttribute('content', prevDescription || '');
            if (ld && ld.parentNode) ld.parentNode.removeChild(ld);
        };
    }, []);
    const [accessCode, setAccessCode] = useState('');
    const [schoolEmail, setSchoolEmail] = useState('');
    const [showCodeModal, setShowCodeModal] = useState(false);
    const [selectedCourse, setSelectedCourse] = useState(null);
    const [error, setError] = useState('');

    const courses = [
        {
            id: 'free-pilot',
            title: 'Free Peer Support Course',
            image: '/assets/FreePilotHelper.JPG',
            needsCode: false,
            route: '/course/free-pilot'
        },
        {
            id: 'college-student',
            title: 'College Pilot Peer Support Course',
            image: '/assets/CollegePilotPeerSupport.PNG',
            needsCode: true,
            validCode: '204892',
            route: '/course/college-student'
        },
        {
            id: 'airline-pilot',
            title: 'Airline Pilot Peer Support Course',
            image: '/assets/AirlinePilot.jpeg',
            needsCode: true,
            validCode: null
            // route: '/course/airline-pilot' // hardcoded route (commented out until live)
        },
        {
            id: 'flight-school',
            title: 'Flight School Peer Support Course',
            image: '/assets/FlightSchoolPeerSupport.jpg',
            needsCode: true,
            validCode: '431702',
            route: '/course/flight-school'
        },
        {
            id: 'corporate-pilot',
            title: 'Corporate Pilot Peer Support Course',
            image: '/assets/CorporatePilotPeerSupport.jpg',
            needsCode: true,
            validCode: null
            // route: '/course/corporate-pilot' // hardcoded route (commented out until live)
        },               
        {
            id: 'flight-attendant',
            title: 'Flight Attendant Peer Support Course',
            image: '/assets/FlightAttendant.jpeg',
            needsCode: true,
            validCode: null
            // route: '/course/flight-attendant' // hardcoded route (commented out until live)
        },
        {
            id: 'air-traffic-controller',
            title: 'Air Traffic Controller Peer Support Course',
            image: '/assets/AirTrafficController.JPG',
            needsCode: true,
            validCode: null
            // route: '/course/air-traffic-controller' // hardcoded route (commented out until live)
        },             
        {
            id: 'military-pilot',
            title: 'Military Pilot Peer Support Course',
            image: '/assets/MilitaryPilot.png',
            needsCode: true,
            validCode: null
            // route: '/course/military-pilot' // hardcoded route (commented out until live)
        },               
        {
            id: 'aircraft-maintenance',
            title: 'Aircraft Maintenance Technician Peer Support Course',
            image: '/assets/AirMaintenanceTechnician.jpeg',
            needsCode: true,
            validCode: null
            // route: '/course/aircraft-maintenance' // hardcoded route (commented out until live)
        },
        {
            id: 'aircraft-dispatcher',
            title: 'Aircraft Dispatcher Peer Support Course',
            image: '/assets/AircraftDispatcher.PNG',
            needsCode: true,
            validCode: null
            // route: '/course/aircraft-dispatcher' // hardcoded route (commented out until live)
        },
        {
            id: 'airport-operations',
            title: 'Airport Operations Peer Support Course',
            image: '/assets/AircraftOperations.jpeg',
            needsCode: true,
            validCode: null
            // route: '/course/airport-operations' // hardcoded route (commented out until live)
        },
        {
            id: 'airline-pilot-family',
            title: 'Airline Pilot Family and Friends Peer Support Course',
            image: '/assets/AirlinePilotFF.jpg',
            needsCode: true,
            validCode: null
            // route: '/course/airline-pilot-family' // hardcoded route (commented out until live)
        },
        {
            id: 'college-pilot-family',
            title: 'College Pilot Family and Friends Peer Support Course',
            image: '/assets/CollegePilotFF.jpg',
            needsCode: true,
            validCode: null
            // route: '/course/college-pilot-family' // hardcoded route (commented out until live)
        },
        {
            id: 'flight-attendant-family',
            title: 'Flight Attendant Family and Friends Peer Support Course',
            image: '/assets/FlightAttendantFF.jpg',
            needsCode: true,
            validCode: null
            // route: '/course/flight-attendant-family' // hardcoded route (commented out until live)
        },
        {
            id: 'military-pilot-family',
            title: 'Military Pilot Family and Friends Peer Support Course',
            image: '/assets/MilitaryPilotFF.jpg',
            needsCode: true,
            validCode: null
            // route: '/course/military-pilot-family' // hardcoded route (commented out until live)
        },
        {
            id: 'air-traffic-controller-family',
            title: 'Air Traffic Controller Family and Friends Peer Support Course',
            image: '/assets/AirTrafficControllerFF.jpg',
            needsCode: true,
            validCode: null
            // route: '/course/air-traffic-controller-family' // hardcoded route (commented out until live)
        }
    ];

    const handleCourseClick = (course) => {
        if (!course.needsCode) {
            navigate(course.route);
        } else {
            setSelectedCourse(course);
            setShowCodeModal(true);
            setError('');
            setAccessCode('');
            setSchoolEmail('');
        }
    };

    const handleCodeSubmit = () => {
        if (!selectedCourse) return;

        if (selectedCourse.validCode === null) {
            setError('Invalid access code. Please try again.');
            return;
        }

        // Special handling for College Pilot Peer Support Course - accept either code OR email in the email field
        if (selectedCourse.id === 'college-student') {
            const input = schoolEmail.trim();
            const emailLower = input.toLowerCase();
            const isValidEmail = emailLower.endsWith('@mtmail.mtsu.edu') || emailLower.endsWith('@mtsu.edu');
            const isValidCode = input === selectedCourse.validCode;

            if (isValidCode || isValidEmail) {
                navigate(selectedCourse.route);
                return;
            }

            setError('Please enter a valid access code or school email address.');
            return;
        }

        if (accessCode === selectedCourse.validCode) {
            navigate(selectedCourse.route);
        } else {
            setError('Invalid access code. Please try again.');
        }
    };

    const closeModal = () => {
        setShowCodeModal(false);
        setSelectedCourse(null);
        setError('');
        setAccessCode('');
        setSchoolEmail('');
    };

    return (
        <>
            <div className="courses-container">
            <div className="col-md-8 mx-auto text-center" style={{ paddingTop: '120px' }}>
                {/* Accessible name for search engines/screen readers */}
                <h1 className="visually-hidden">Courses</h1>
                <h1 className="display-4 fw-bold mb-4">Choose Your Course</h1>
                <div className="subtitle-with-lines mb-4">
                    <div className="line"></div>
                    <h2 className="subtitle">Select from our range of peer support courses designed for aviation professionals</h2>
                    <div className="line"></div>
                </div>
            </div>

            <div className="courses-grid">
                {courses.map((course) => (
                    <div key={course.id} className="course-card">
                        <div
                            className="course-image"
                            onClick={() => handleCourseClick(course)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    handleCourseClick(course);
                                }
                            }}
                            role="button"
                            tabIndex={0}
                            aria-label={`View ${course.title}`}
                        >
                            <img src={course.image} alt={course.title} />
                        </div>
                        <div className="course-content">
                            <h3 className="course-title">{course.title}</h3>

                            <button
                                className="btn btn-primary"
                                onClick={() => handleCourseClick(course)}
                            >
                                Get Started
                            </button>
                        </div>
                    </div>
                ))}
            </div>

            {/* Access Code Modal */}
            {showCodeModal && (
                <div
                    className="modal-overlay"
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="access-code-modal-title"
                >
                    <div className="modal-content">
                        {selectedCourse?.id === 'college-student' ? (
                            <>
                                <div className="modal-header">
                                    <h3 id="access-code-modal-title">Verify Your Institution</h3>
                                    <button
                                        className="close-btn"
                                        onClick={closeModal}
                                        aria-label="Close modal"
                                    >
                                        ×
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <p>Access to the College Pilot Peer Support Course is limited to students and faculty at PilotHelper partner institutions.</p>
                                    <p>Enter your access code or official school email address to continue.</p>
                                    <input
                                        type="text"
                                        value={schoolEmail}
                                        onChange={(e) => setSchoolEmail(e.target.value)}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                handleCodeSubmit();
                                            }
                                        }}
                                        placeholder="Access code or name@university.edu"
                                        className="access-code-input"
                                        aria-label="Access code or school email address"
                                        aria-describedby={error ? "access-code-error" : undefined}
                                    />
                                    {error && <p id="access-code-error" className="error-message" role="alert" style={{ color: 'red' }}>{error}</p>}
                                </div>
                                <div className="modal-footer">
                                    <button className="cancel-btn" onClick={closeModal}>Cancel</button>
                                    <button className="submit-btn" onClick={handleCodeSubmit}>Continue</button>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="modal-header">
                                    <h3 id="access-code-modal-title">Enter Access Code</h3>
                                    <button
                                        className="close-btn"
                                        onClick={closeModal}
                                        aria-label="Close modal"
                                    >
                                        ×
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <p>Please enter your access code for:</p>
                                    <h4>{selectedCourse?.title}</h4>
                                    <input
                                        type="text"
                                        value={accessCode}
                                        onChange={(e) => setAccessCode(e.target.value)}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                handleCodeSubmit();
                                            }
                                        }}
                                        placeholder="Enter access code"
                                        className="access-code-input"
                                        aria-label="Access code"
                                        aria-describedby={error ? "access-code-error" : undefined}
                                    />
                                    {error && <p id="access-code-error" className="error-message" role="alert" style={{ color: 'red' }}>{error}</p>}
                                </div>
                                <div className="modal-footer">
                                    <button className="cancel-btn" onClick={closeModal}>Cancel</button>
                                    <button className="submit-btn" onClick={handleCodeSubmit}>Submit</button>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            )}
        </div>
        </>
    );
};

export default Courses;